<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.assign_representative_department' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickBtnCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <form #f="ngForm" (ngSubmit)=" f.form.valid && onCreateGroup()"
    appFocusFirstElement style="margin-top: 10px;">
    <mat-dialog-content>  
          <div class="row">
            <div class="col-sm-12">
                <mat-form-field class="w-100">
                  <mat-label>
                    {{'search_form.department_representative' | translate}}
                  </mat-label>
                  <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                  [(ngModel)]="userGroup.representativeIdString" >
                  <input (keydown)="$event.stopPropagation()" type="text"  matInput placeholder="{{'alert.search_department_representative_placeholder' | translate}}"
                   style="padding-left: 15px;height: 48px;color: #000000;" (input)="onInputChange($event)" maxlength="200"/>
                  <mat-divider></mat-divider>
                    <mat-option>{{'search_form.department_representative_choose' | translate}}</mat-option>
                      <mat-option (click)="this.commonService.closeDropdownList(this.statusSelect)" [ngStyle]="{'display': item.isDeleted == false ? null : 'none'}" 
                      [value]="item.id" *ngFor="let item of listFilterUserInDepartment">{{item.email}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
          </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <!-- Huỷ bỏ & Lưu -->
    <mat-dialog-actions align="center">
      <button mat-stroked-button color="primary" class="mr-3" (click)="onClickBtnCancel()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button mat-raised-button [disabled]="(!isFormChanging && !change) || (!data.representativeIdString && userGroup.representativeIdString == null)" type="submit" cdkFocusInitial color="primary">
        <mat-icon class="mr-0">save</mat-icon>
        {{'button.update_department' | translate}}
      </button>
    </mat-dialog-actions>
  </form>
  